import React, { Component } from 'react';

import Helmet from './Helmet';

export default class PrivacyHelmet extends Component {
  render() {
    return (
      <Helmet
        title="Privacy Policy | Canny"
        meta={[{ name: 'robots', content: 'noindex,follow' }]}
      />
    );
  }
}
